export const FEATURE_TYPE = {
  SHORTSTAY: 'SHORTSTAY',
  SHORTSTAY_PACKAGE: 'SHORTSTAY_PACKAGE',
  EXPERIENCES: 'EXPERIENCES',
  EXTENDEDSTAY: 'EXTENDEDSTAY',
  VENUE: 'VENUE',
  FOOD_AND_DRINKS: 'FOOD_AND_DRINKS',
  BLOG_CATEGORY: 'FAQ_CATEGORY',
  FAQ_CATEGORY: 'BLOG_CATEGORY',
  JOB_CATEGORY: 'JOB_CATEGORY',
  BAG2BAG_TRUE_BELIEVER: 'BAG2BAG_TRUE_BELIEVER',
  BAG2BAG_PREMIUM: 'BAG2BAG_PREMIUM',
  OTHERS: 'OTHERS',
  FOOD: 'FOOD',
  DRINKS: 'DRINKS',
  NGO_CARD: 'NGO_CARD',
  PACKAGES: 'PACKAGES',
  GAMES: 'GAMES',
  CONTEST: 'CONTEST',
  SITEMAP_SHORTSTAY: 'SITEMAP_SHORTSTAY',
  SITEMAP_EXTENDEDSTAY: 'SITEMAP_EXTENDEDSTAY',
  PROMOTION: 'PROMOTION',
  GIFT_CARD: 'GIFT_CARD',
  MEALS: 'MEALS',
  COMBO: 'COMBO',
  ESSENTIAL: 'ESSENTIAL',
  TRANSPORT: 'TRANSPORT',
  ACTIVITIES: 'ACTIVITIES',
  RESORT_DAYOUTING: 'RESORT_DAYOUTING',
  NEW_YEAR_PACKAGES: 'NEW_YEAR_PACKAGES',
  STAYCATION_PACKAGES: 'STAYCATION_PACKAGES',
  ACTIVITY_DAYOUTING: 'ACTIVITY_DAYOUTING',
  EXTENDEDSTAY_PACKAGE: 'EXTENDEDSTAY_PACKAGE',
};

export const WEEKDAYS_CONSTANT: { display: string; value: number }[] = [
  {display: 'Mon', value: 1},
  {display: 'Tue', value: 2},
  {display: 'Wed', value: 3},
  {display: 'Thu', value: 4},
  {display: 'Fri', value: 5},
  {display: 'Sat', value: 6},
  {display: 'Sun', value: 7},
];

export const LOCALITY_ENUMS = {
  CITY: 'CITY',
  LOCALITY: 'LOCALITY',
  STATE: 'STATE',
  COUNTRY: 'COUNTRY',
  REGION: 'REGION',
  SIGHT_SEEING: 'SIGHT_SEEING',
};

export const ENQURY_TYPES = {
  GENERAL_ENQUIRY: 'GENERAL_ENQUIRY',
  JOB_ENQUIRY: 'JOB_ENQUIRY',
  ROOMS_NOT_AVAILABLE_ENQUIRY: 'ROOMS_NOT_AVAILABLE_ENQUIRY',
  NEW_PROPERTY_ENQUIRY: 'NEW_PROPERTY_ENQUIRY',
  PROMOTE_YOUR_BUSINESS: 'PROMOTE_YOUR_BUSINESS',
  CORPORATE_ENQUIRY: 'CORPORATE_ENQUIRY',
};
export const PROPERTY_REQUEST_STATUS = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};


export class VendorAppSettingsModel {
  androidVersion: number;
  supportedAndroidAppVersions?: number[];
}
